module.exports = __webpack_public_path__ + "img/mastercard.d60f92d4.svg";